export * from "./mixpanel";

export enum HeaderEvents {
  CLICKED_HEADER_LOGO = "clicked_header_logo",
  NAVIGATE_TO_FEED_FROM_HOME = "navigate_to_feed_from_home",
  CLICKED_SUBSCRIBE_FROM_HEADER = "clicked_subscribe_from_header",
  CLICKED_SIGN_IN = "clicked_sign_in",
  CLICKED_PRIVACY_POLICY = "clicked_privacy_policy",
  CLICKED_TERMS_OF_SERVICE = "clicked_terms_of_service",
  CLICKED_ABOUT_US = "clicked_about_us",
  CLICKED_TIXOLOGI = "clicked_tixologi",
  CLICKED_BLOG = "clicked_blog",
}
